import { render, staticRenderFns } from "./AvatarText.vue?vue&type=template&id=7a8d88ef&scoped=true"
import script from "./AvatarText.vue?vue&type=script&lang=js"
export * from "./AvatarText.vue?vue&type=script&lang=js"
import style0 from "./AvatarText.vue?vue&type=style&index=0&id=7a8d88ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8d88ef",
  null
  
)

export default component.exports